import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TodaysApptUserFlowSteps } from 'features/order-tracker/pages/order-summary/components/SnapshotCardSection/constants';
import { OPENREACH_APPOINTMENT_TYPES, ORDER_STATUSES } from 'features/order-tracker/utils/entries';
import { getStatuses } from 'features/order-tracker/store/selectors';
import { ORDER_STATUS_IN_PROGRESS } from 'features/order-tracker/services/constants';

import { APPOINTMENT_AMENDABLE_STATUSES } from '../sagas/services/helpers/constants';
import { APPT_USER_PATH_STEP_STORAGE_NAME, MS_IN_HALF_AN_HOUR } from './contstants';

export const useTodaysOpenreachAppointmentManager = (
  appointments: common.EngineerAppointment[],
): [number | null, (nextStep: number) => void] => {
  const {
    orderStatuses,
    orderStatusFromGOC,
  } = useSelector(getStatuses);
  const orderStatus = orderStatusFromGOC || orderStatuses[0];
  const [apptUserPathStep, setApptUserPathStep] = useState<number | null>(null);

  const setNextStep = (nextStep: number): void => {
    setApptUserPathStep(nextStep);
    localStorage.setItem(APPT_USER_PATH_STEP_STORAGE_NAME, nextStep.toString());
  };

  useEffect(() => {
    const appointmentWhichIsToday = appointments.find(
      ({ isAppointmentToday, type, status }) =>
        OPENREACH_APPOINTMENT_TYPES.includes(type) &&
        APPOINTMENT_AMENDABLE_STATUSES.includes(status) &&
        ORDER_STATUSES[orderStatus] === ORDER_STATUS_IN_PROGRESS &&
        isAppointmentToday,
    );

    if (appointmentWhichIsToday) {
      const [, endTimeSlot] = appointmentWhichIsToday.timeSlot.split(' and ');
      const appointmentDate = new Date(`${appointmentWhichIsToday.engineeringAppointmentDate.split('T')[0]}T${endTimeSlot}:00`);
      const isHalfAnHourBeforeEngineerAppt = appointmentDate.getTime() - Date.now() < MS_IN_HALF_AN_HOUR;
      const isEndOfScheduledApptTimeSlot = appointmentDate.getTime() <= Date.now();
      const storedStep = parseInt(localStorage.getItem(APPT_USER_PATH_STEP_STORAGE_NAME) || '', 10);
      const currentStep = isEndOfScheduledApptTimeSlot && TodaysApptUserFlowSteps.EndOfScheduledTimeSlot
        || isHalfAnHourBeforeEngineerAppt && TodaysApptUserFlowSteps.HalfAnHourBefore
        || TodaysApptUserFlowSteps.Init;
      const resultStep = storedStep > currentStep ? storedStep : currentStep;
      setNextStep(resultStep);
    } else {
      setApptUserPathStep(null);
      localStorage.removeItem(APPT_USER_PATH_STEP_STORAGE_NAME);
    }
  }, [appointments]);

  return [apptUserPathStep, setNextStep];
};
